export default "/imgs/investigation-05.png"